// extracted by mini-css-extract-plugin
module.exports = {"icons":"contractualaccountselect_icons__2iHbb","textContent":"contractualaccountselect_textContent__2Q28R"};